import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Pagination, Icon, Empty, message} from 'antd';
import {Redirect} from 'react-router';
import './searchDetail.less';
import {changeSearchDetail} from '../../../store/reduces/frontEnd';
import utils from '../../../utils/common';

@connect(
  (state) => ({searchInfo: state}),
  {changeSearchDetail},
)

class SearchDetail extends Component {
  state = {
    type: null, // search 内容搜索 property 软硬件属性搜索
    list: [],
    sortIndex: 1, // 1 综合 2 价格up 3 价格low
    pageNumber: 1,
    searchContent: '', // 上一个搜索的内容
    classification: 0, // 软件搜寻的分类 单件 套餐
    total: 0, // 总页数
    id: null, // 一级商品id；当type为property时，为软件硬件的分类
    redirect: false,
    isSetMeal: 0, // 是否是套餐

    sourceCMS: '', // 来源标识
  }

  async componentWillMount() {
    if (window.common.loginOut(this)) {
      const info = this.props.location.state;
      const storeInfo = this.props.searchInfo.frontEnd;
      storeInfo.type !== null ? Object.assign(info, storeInfo) : null;

      const sourceCMS = window.localStorage.getItem('sourceCMS') || '';
      await this.setState({...info, sourceCMS});

      this.getList();
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  async componentWillReceiveProps(props) {
    const info = props.location.state;
    const storeInfo = props.searchInfo.frontEnd;
    storeInfo.type !== null ? Object.assign(info, storeInfo) : null;
    await this.setState(info);
    this.getList();
  }

  componentWillUnmount() {
    const {
      classification, sortIndex, searchContent, pageNumber
    } = this.state;
    const info = {
      classification, sortIndex, searchContent, type: this.state.type, id: this.state.id, pageNumber
    };
    this.props.changeSearchDetail(info);
  }

  // 获取搜寻的商品列表
  getList = () => {
    const {
      id, type, sortIndex, pageNumber, searchContent, classification, sourceCMS
    } = this.state;
    let params = {
      page_size: 10,
      current_page: pageNumber,
      status: 0,
    };
    let sortWay = null;
    switch (sortIndex) {
      case 2:
        sortWay = '00';
        break;
      case 3:
        sortWay = '01';
        break;
      default:
        sortWay = null;
        break;
    }
    switch (type) {
      case 'property':
        params.goods_property = id;
        break;
      case 'category':
        params.goods_category_id = id;
        break;
      case 'search':
        params.goods_name = searchContent;
        break;
      default:
        null;
    }
    if (sourceCMS === '1') {
      params.goods_name = searchContent;
      params.is_source_cms = 1;
    }
    sortWay ? params.sort_way = sortWay : null;
    params = utils.dealElement(params);
    let url = 'goods.getgoodslist';
    const isSetMeal = type === 'property' && id === 1 && classification === 0 ? 1 : 0;
    if (isSetMeal) {
      url = 'eps.homepage.getgoodspackage';
      params = {sort: sortIndex, page_no: pageNumber, page_num: 10};
    }
    window.api(url, params).then(res => {
      if (isSetMeal) {
        res.goods_package_list.length > 0 ? this.setState({list: res.goods_package_list, total: Number(res.count), isSetMeal}) : this.setState({list: []});
      } else {
        res.goods_list.length > 0 ? this.setState({list: res.goods_list, total: res.total_result, isSetMeal}) : this.setState({list: []});
      }
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 改变排序方法
  changeSort = async (index) => {
    const info = this.state.sortIndex === 2 && index === 2 ? {sortIndex: 3, pageNumber: 1} : {sortIndex: index, pageNumber: 1};
    await this.setState(info);
    this.getList();
  }

  // 改变分类
  changeClassification = async (index) => {
    await this.setState({classification: index, sortIndex: 1});
    this.getList();
  }

  // 跳转到详情页
  toDetail = (id) => {
    const {isSetMeal} = this.state;
    const type = isSetMeal ? 'setMeal' : 'goods';
    this.props.history.push('/goodsDetail', {id, type});
  }

  // 翻页
  changePage = async (pageNumber) => {
    await this.setState({pageNumber});
    this.getList();
  }

  render() {
    const {
      type, id, list, pageNumber, total, redirect, sortIndex, classification, isSetMeal, sourceCMS
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);
    return (
      <div id="searchDetail">
        {
          type === 'property' && id === 1 ? <section className="classification">
            <div>分类</div>
            <ul>
              <li className={classification === 0 ? 'isChecked' : null} onClick={this.changeClassification.bind(this, 0)}>套餐</li>
              <li className={classification === 1 ? 'isChecked' : null} onClick={this.changeClassification.bind(this, 1)}>单件商品</li>
            </ul>
          </section> : null
        }
        <section className="container sort">
          <ul>

            {sourceCMS === '1' && (
              <div className="sourceCMS">
                流量商品
              </div>
            )}

            <li onClick={this.changeSort.bind(this, 1)}>
              <p className={sortIndex === 1 ? 'isChecked' : null}>综合</p>
            </li>
            <li onClick={this.changeSort.bind(this, 2)}>
              <p className={sortIndex > 1 ? 'isChecked' : null}>价格</p>
              <div className="toggle">
                <div className={sortIndex === 2 ? 'choose1 smallToBig' : 'smallToBig'}><Icon type="caret-up" /></div>
                <div className={sortIndex === 3 ? 'choose2 bigToSmall' : 'bigToSmall'}><Icon type="caret-down" /></div>
              </div>
            </li>
          </ul>

          {sourceCMS === '1' && (
            <div className="search-box">
              <input
                type="text"
                placeholder="搜索商品"
                value={this.state.searchContent}
                onChange={e => this.setState({searchContent: e.target.value})}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    this.setState({pageNumber: 1}, () => {
                      this.getList();
                    });
                  }
                }}
              />
              <button
                onClick={() => {
                  this.setState({pageNumber: 1}, () => {
                    this.getList();
                  });
                }}
              >
                <Icon type="search" />
              </button>
            </div>
          )}

        </section>
        <section className="list">
          { list.length > 0 ? (
            <ul className="sku-list">
              {
                list.map((item, index) => (
                  isSetMeal ? <li key={index} onClick={this.toDetail.bind(this, item.id)}>
                    <img src={item.package_picture} />
                    <div>
                      <div className="price">
                        <p><em>¥</em>{Number(item.package_amt).toFixed(2)}</p>
                      </div>
                      <h2>{item.package_name}</h2>
                    </div>
                  </li> : <li key={index} onClick={this.toDetail.bind(this, item.id)}>
                    <img src={item.goods_picture} />
                    <div>
                      <div className="price">
                        <p><em>¥</em>{Number(item.discount_price).toFixed(2)}</p>
                        <p hidden={item.discount_price === item.sale_price}>¥{Number(item.sale_price).toFixed(2)}</p>
                      </div>
                      <h2>{item.goods_name}</h2>
                    </div>
                  </li>
                ))
              }
            </ul>) : <div className="default"><Empty /></div>
          }
        </section>
        <section className="pagination" hidden={list.length === 0}>
          <Pagination
            showQuickJumper
            showSizeChange
            current={pageNumber}
            defaultCurrent={1}
            defaultPageSize={10}
            total={total}
            onChange={this.changePage}
          />
        </section>
      </div>
    );
  }
}

export default SearchDetail;



// WEBPACK FOOTER //
// ./src/containers/frontEnd/searchDetail/searchDetail.jsx